<template lang="html">
  <div class="main-container">
    <v-row dense no-gutter>
      <v-col cols="12" md="6">
        <v-row dense no-gutter>
          <v-col cols="12" md="8">
            <v-autocomplete
              v-model="indicator"
              label="Kies indicator"
              :items="filteredIndicators"
              item-text="omschrijving"
              return-object
              clearable
              :search-input.sync="searchString"
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row dense no-gutter>
          <v-col cols="12" md="4">
            <v-select
              v-model="pijler"
              :items="pijlers"
              item-text="label"
              item-value="value"
              label="Filter op pijler (optioneel)"
            >
            </v-select>
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="thema"
              :items="themas"
              item-text="label"
              item-value="value"
              label="Filter op deelsector (optioneel)"
            >
            </v-select>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="6">
        <v-row dense no-gutter>
          <v-col cols="12" md="8">
            <v-autocomplete
              v-model="indicator2"
              label="Kies tweede indicator (optioneel)"
              :items="filteredIndicators2"
              item-text="omschrijving"
              return-object
              clearable
              :search-input.sync="searchString2"
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row dense no-gutter>
          <v-col cols="12" md="4">
            <v-select
              v-model="pijler2"
              :items="pijlers"
              item-text="label"
              item-value="value"
              label="Filter op pijler (optioneel)"
            >
            </v-select>
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="thema2"
              :items="themas"
              item-text="label"
              item-value="value"
              label="Filter op deelsector (optioneel)"
            >
            </v-select>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row dense no-gutter>
      <v-col cols="12" md="6">
        <v-radio-group v-model="normalization" row>
          <v-radio label="Absoluut aantal" value="none"> </v-radio>
          <v-radio label="Aantal per inwoner" value="perInhabitant"> </v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "Menu",
  data: () => ({
    indicator: null,
    indicator2: null,
    pijler: null,
    pijler2: null,
    thema: null,
    thema2: null,
    searchString: "",
    searchString2: "",
    normalization: "perInhabitant", //'perInhabitant' or 'none'
    aggregation: "deelregio"
  }),
  mounted() {
    this.$store.dispatch("updateNormalization", this.normalization);
    this.$store.dispatch("updateAggregation", this.aggregation);
    if (this.indicators.length > 0) {
      this.indicator = this.indicators[0];
    }
  },
  computed: {
    indicators() {
      return this.$store.getters.indicators;
    },
    filteredIndicators() {
      return this.indicators.filter(
        i =>
          (!this.pijler || i.pijler == this.pijler) &&
          (!this.thema || i.thema == this.thema)
      );
    },
    filteredIndicators2() {
      return this.indicators.filter(
        i =>
          (!this.pijler2 || i.pijler == this.pijler2) &&
          (!this.thema2 || i.thema == this.thema2)
      );
    },
    pijlers() {
      return [{ label: "Alle", value: null }].concat(
        this.indicators
          .map(i => i.pijler)
          .filter((v, i, a) => a.indexOf(v) === i)
          .sort()
          .map(p => ({ label: p, value: p }))
      );
    },
    themas() {
      return [{ label: "Alle", value: null }].concat(
        this.indicators
          .map(i => i.thema)
          .filter((v, i, a) => a.indexOf(v) === i)
          .filter(t => t && t.trim().length > 0)
          .filter(t => t != "?")
          .sort()
          .map(t => ({ label: t, value: t }))
      );
    }
  },
  watch: {
    indicators() {
      this.indicator = this.indicators[0];
    },
    normalization() {
      this.$store.dispatch("updateNormalization", this.normalization);
    },
    aggregation() {
      this.$store.dispatch("updateAggregation", this.aggregation);
    },
    indicator() {
      this.$store.dispatch("updateIndicator", this.indicator);
    },
    indicator2() {
      this.$store.dispatch("updateIndicator2", this.indicator2);
    },
    pijler() {
      this.$store.commit("SET_PIJLER", this.pijler);
    },
    thema() {
      this.$store.commit("SET_THEMA", this.thema);
    }
  }
};
</script>

<style lang="css" scoped>
.main-container {
  padding: 20px;
}
</style>
